//Jquery
import "./jquery-global.js";
import $, {ajax} from "jquery";

export function initLookupAddress() {
    $('[data-id="address-holder"]:not([data-address-initialized])').each(function (index, element) {
        let $element = $(element);
        // initialize postcode anywhere

        let options = {key: "ZW62-CA99-RC92-HA68"};
        let fields = [];
        let pcaFields = $element.find('[data-pca-field]');
        pcaFields.each(function (i, el) {
            let $el = $(el);
            let field = {
                element: $el.attr('id'),
                field: $el.data('pca-field')
            };

            switch ($el.data('pca-field')) {
                case "":
                    field.mode = pca.fieldMode.SEARCH;
                    break;
                case "CountryName":
                    field.mode = pca.fieldMode.COUNTRY;
                    break;
                case "PostalCode":
                    break;
                default:
                    field.mode = pca.fieldMode.POPULATE;
            }
            fields.push(field);
        });

        let control = new pca.Address(fields, options);
        control.listen("populate", function (address, variations) {
            let addressLine1 = [], addressLine2 = [];
            pcaFields.each(function (i, el) {
                let $el = $(el);
                if ($el.data('pca-search')) {
                    $el.val('');
                }

                if ($el.data('pca-field') === 'BuildingNumber') {
                    if (address.SubBuilding.length > 0) {
                        addressLine1.push(address.SubBuilding)
                    }
                    if (address.BuildingNumber.length > 0) {
                        addressLine1.push(address.BuildingNumber)
                    }
                    if (address.BuildingName.length > 0 && address.SubBuilding.length === 0) {
                        addressLine1.push(address.BuildingName)
                    }
                    $el.val(addressLine1.join(" - "));
                }

                if ($el.data('pca-field') === 'Street') {
                    if (address.Street.length > 0) {
                        addressLine2.push(address.Street);
                    }
                    if (address.Line2.length > 0 && address.Street.length === 0) {
                        addressLine2.push(address.Line2);
                    }
                    $el.val(addressLine2.join(" - "));
                }
                $el.change();
            });
        });

        $element.data('pca-control', control);
        $element.data('address-initialized', true);
    });
}